import * as types from './types'

export const getSubTrades = (payload: any) => ({
  type: types.GET_SUB_TRADES,
  payload,
})

export const getSubTrade = (payload: any) => ({
  type: types.GET_SUB_TRADE,
  payload,
})

export const addSubTrade = (payload: any) => ({
  type: types.ADD_SUB_TRADES,
  payload,
})

export const editSubTrade = (payload: any) => ({
  type: types.EDIT_SUB_TRADES,
  payload,
})

export const deleteSubTrade = (payload: any) => ({
  type: types.DELETE_SUB_TRADE,
  payload,
})

export const getLockedSubTrades = (payload: any) => ({
  type: types.GET_LOCKED_SUB_TRADES,
  payload,
})

export const startLoadingSubTrades = () => ({
  type: types.START_LOADING_SUB_TRADES,
  payload: null,
})

export const stopLoadingSubTrades = () => ({
  type: types.STOP_LOADING_SUB_TRADES,
  payload: null,
})

export const addSubTradeFee = (payload: any) => ({
  type: types.ADD_SUB_TRADE_FEE,
  payload,
})

export const editSubTradeFee = (payload: any) => ({
  type: types.EDIT_SUB_TRADE_FEE,
  payload,
})

export const addLockedSubTradeFee = (payload: any) => ({
  type: types.ADD_LOCKED_SUB_TRADE_FEE,
  payload,
})

export const editLockedSubTradeFee = (payload: any) => ({
  type: types.EDIT_LOCKED_SUB_TRADE_FEE,
  payload,
})

export const deleteSubTradeFee = (payload: any) => ({
  type: types.DELETE_SUB_TRADE_FEE,
  payload,
})

export const changeAllocationSubTrade = (payload: any) => ({
  type: types.CHANGE_ALLOCATION_SUB_TRADE,
  payload,
})

export const changeWireInstructionSubTrade = (payload: any) => ({
  type: types.CHANGE_WIRE_INSTRUCTION_SUB_TRADE,
  payload,
})

export const addTemporarySubTrade = (payload: any) => ({
  type: types.ADD_TEMPORARY_SUB_TRADE,
  payload,
})

export const updateSubTradeClientId = (payload: any) => ({
  type: types.UPDATE_SUB_TRADE_CLIENT_ID,
  payload,
})

export const settleSubTradeAction = (payload: any) => ({
  type: types.SETTLE_SUB_TRADE,
  payload,
})

export const unsettleSubTradeAction = (payload: any) => ({
  type: types.UNSETTLE_SUB_TRADE,
  payload,
})

export const terminateSubTradeAction = (payload: any) => ({
  type: types.TERMINATE_SUB_TRADE,
  payload,
})
